// Firebase Configuration and Initialization
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyA8Yptm6JJHcF6SVXWHVFzG3dDH8PnWpK8",
    authDomain: "mmao-6395.firebaseapp.com",
    projectId: "mmao-6395",
    storageBucket: "mmao-6395.firebasestorage.app",
    messagingSenderId: "266933758796",
    appId: "1:266933758796:web:1601471965ca4d4db9bde9",
    measurementId: "G-DMRCKF19WH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export const db = getFirestore(app);

export const storage = getStorage(app);

export default app;